const INTEGRATION_DATA = [
    {
        name: "Creatio",
        value: "creatio",
        route: "creatio",
        filters: ["viber", "telegram", "whatsapp"],
        svg: true,
    },
    {
        name: "Perfectum",
        value: "perfectum",
        route: "perfectum",
        filters: ["viber", "telegram", "whatsapp"],
    },
    {
        name: "KommoCRM",
        value: "kommo",
        route: "kommo-crm",
        // !TODO: "viber_voip" and "tiktok" are hidden for now, only API is offered there
        filters: ["viber", "telegram", "whatsapp"],
        svg: true,
    },
    {
        name: "Bitrix24",
        value: "bitrix",
        route: "bitrix24",
        // !TODO: "viber_voip" and "tiktok" are hidden for now, only API is offered there
        filters: ["viber", "telegram", "whatsapp"],
        svg: true,
    },
    {
        name: "KeyCRM",
        value: "keycrm",
        route: "key-crm",
        filters: ["viber"],
        svg: true,
        noPadding: true,
    },
    {
        name: "KeepinCRM",
        value: "keepin",
        route: "keepin",
        filters: ["viber", "telegram", "whatsapp"],
        svg: true,
        noPadding: true,
    },
    {
        name: "OneBox",
        value: "onebox",
        route: "onebox",
        filters: ["viber", "telegram", "whatsapp"],
        svg: true,
        noPadding: true,
    },
    {
        name: "TrendCRM",
        value: "trend",
        route: "trend-crm",
        filters: ["viber"],
    },
    {
        name: "PlanFix",
        value: "planfix",
        route: "plan-fix",
        filters: ["viber"],
        svg: true,
        noPadding: true,
    },
    {
        name: "Wepster",
        value: "wepster",
        route: "wepster",
        filters: ["viber"],
    },
    {
        name: "Apix-Drive",
        value: "apix",
        route: "apix-drive",
        filters: ["viber"],
        svg: true,
        noPadding: true,
    },
    {
        name: "SalesDrive",
        value: "sales-drive",
        route: "sales-drive",
        filters: ["viber", "telegram", "whatsapp"],
        svg: true,
        noPadding: true,
    },
    {
        name: "ROapp",
        value: "remonline",
        route: "remonline",
        filters: ["viber", "telegram", "whatsapp"],
        svg: true,
    },
    {
        name: "ConnectiveOne",
        value: "connectiveone",
        route: "connectiveone",
        filters: ["viber", "telegram", "whatsapp"],
        svg: true,
        noPadding: true,
    },
    {
        name: "G-plus",
        value: "g-plus",
        route: "g-plus",
        filters: ["viber"],
    },
    {
        name: "NovaTalks",
        value: "novatalks",
        route: "novatalks",
        filters: ["viber"],
        svg: true,
        noPadding: true,
    },
    {
        name: "LBS",
        value: "lbs",
        route: "lbs",
        filters: ["viber", "telegram", 'whatsapp'],
    },
    {
        name: "Uspacy",
        value: "uspacy",
        route: "uspacy",
        filters: ["whatsapp", "viber", "telegram"],
        svg: true,
        noPadding: true,
    },
    {
        name: "Odoo",
        value: "odoo",
        route: "odoo",
        filters: ["whatsapp", "viber", "telegram"],
        svg: true,
    },
    {
        name: "NetHunt",
        value: "nethunt",
        route: "nethunt",
        filters: ["whatsapp", "viber", "telegram"],
        svg: true,
        noPadding: true,
    },
    {
        name: "EasyBusy",
        value: "easybusy",
        route: "easybusy",
        filters: ["viber"],
    },
    {
        name: "Amploo",
        value: "amploo",
        route: "amploo",
        filters: ["whatsapp", "viber", "telegram"],
    },
    {
        name: "Sitniks",
        value: "sitniks",
        route: "sitniks",
        filters: ["viber", "whatsapp"],
        svg: true,
        noPadding: true,
    },
    {
        name: "SendPulse",
        value: "sendPulse",
        route: "sendPulse",
        filters: ["viber"],
        svg: true,
    },
    {
        name: "CleverBox",
        value: "cleverBox",
        route: "cleverBox",
        filters: ["whatsapp", "telegram"],
    },
    {
        name: "VoipTime",
        value: "voipTime",
        route: "voipTime",
        filters: ["viber", "telegram"],
        svg: true,
        noPadding: true,
    },
    {
        name: "TradeEVO",
        value: "tradeEVO",
        route: "tradeEVO",
        filters: ["viber", "telegram", "whatsapp"],
    },
    {
        name: "Pager",
        value: "pager",
        route: "pager",
        filters: ["viber", "telegram", "whatsapp"],
        svg: true,
        noPadding: true,
    },
    {
        name: "Prodazhy",
        value: "prodazhy",
        route: "prodazhy",
        filters: ["viber", "telegram", "whatsapp"],
        svg: true,
        noPadding: true,
    },
    {
        name: "Aliks",
        value: "aliks",
        route: "aliks",
        filters: ["viber"],
    },
    {
        name: "NextCRM",
        value: "nextcrm",
        route: "next-crm",
        filters: ["viber", "whatsapp"],
        svg: true,
    },
    {
        name: "Keruj",
        value: "keruj",
        route: "keruj",
        filters: ["viber", "telegram", "whatsapp"],
        svg: true,
        noPadding: true,
    },
    {
        name: "Skynum",
        value: "skynum",
        route: "skynum",
        filters: ["viber", "telegram", "whatsapp"],
    },
    {
        name: "X10CRM",
        value: "x10crm",
        route: "x10-crm",
        filters: ["viber", "telegram", "whatsapp"],
    },
    {
        name: "JediDesk",
        value: "jedidesk",
        route: "jedidesk",
        filters: ["viber", "telegram", "whatsapp"],
    },
    {
        name: "API",
        value: "api",
        route: "api",
        filters: ["whatsapp", "viber", "telegram", "viber_voip", "tiktok"],
        svg: true,
        noPadding: true,
    },
];
// OBJECT INTEGRATION_DATA - KEY: route
const CRM_SYSTEM = INTEGRATION_DATA.reduce((acc, item) => {
    acc[item.route] = item;
    return acc;
}, {});

export { INTEGRATION_DATA, CRM_SYSTEM };
